import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";

const api = new APICore();


export const uploadImage = createAsyncThunk(
  "customImage/uploadImage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.createWithFile(Url.UPLOAD_IMAGE, data);
      // showSuccess(response.data.message);
      return response.data.data;
    } catch (error) {
      showError(error)
      // return rejectWithValue(error);
    }
  }
);

export const generateCustomMedia = createAsyncThunk(
  "customImage/generateCustomMedia",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.GRNRTATE_CUSTOM_MEDIA, data);
      // showSuccess(response.data.message);
      return response.data.data;
    } catch (error) {
      showError(error)
      // return rejectWithValue(error);
    }
  }
);
